// extracted by mini-css-extract-plugin
module.exports = {"RoundPlusButton":"style_RoundPlusButton__RLMHI","circle":"style_circle__3fVGc","text":"style_text__y-Yfn"};